import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
  role: null,
};

const currentUserSlice = createSlice({
  name: "currentUserSlice",
  initialState,
  reducers: {
    setCurrentUser: (state, { payload: { data, role } }) => {
      state.data = data;
      state.role = role;
    },
    updateCurrentUser: (state, { payload }) => {
      state.data = { ...state.data, ...payload };
    },
    clearCurrentUserSlice: (state) => {
      state.data = {};
    },

    deleteCurrentUserDoctorDocument: (state, { payload }) => {
      state.data = {
        ...state.data,
        uploadApplications: state.data.uploadApplications.filter(
          (document) => document.fileType !== payload,
        ),
      };
    },
    upsertCurrentUserDoctorDocument: (state, { payload }) => {
      let isDocumentExists = state.data.uploadApplications.find(
        (document) => document.fileType === payload.fileType,
      );
      state.data = {
        ...state.data,
        uploadApplications: isDocumentExists
          ? state.data.uploadApplications.map((document) =>
              document.fileType === payload.fileType ? payload : document,
            )
          : [...state.data.uploadApplications, payload],
      };
    },
  },
});

export const {
  setCurrentUser,
  updateCurrentUser,
  clearCurrentUserSlice,
  deleteCurrentUserDoctorDocument,
  upsertCurrentUserDoctorDocument,
} = currentUserSlice.actions;
export const currentUserReducer = currentUserSlice.reducer;
